import * as React from 'react';
import Layout from 'antd/lib/layout';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import Spin from 'antd/lib/spin';
import BoxPresentation from './BoxPresentation';
import BoxForm from './BoxForm';
import CSSTransition from 'react-transition-group/CSSTransition';
import './LogIn.scss';
import { ICredencial, Recovery } from '../../Models/Security';
import { ISessionState, EStatusRequest } from '../../Reducers/Session/index';
import ForgetPassword from '../../Components/ForgetPassword';

export interface ILogInState {
	recovery: boolean;
	animated: boolean;
}

export interface ILogInProps extends ISessionState {
	onLogin: (cred: ICredencial) => void;
	onRecovery: (data: Recovery) => void;
	status: EStatusRequest;
	setStatus: (status: EStatusRequest) =>  void;
}

class LogIn extends React.Component<ILogInProps, ILogInState> {
	constructor(props: ILogInProps) {
		super(props);
		this.state = {
			recovery: false,
			animated: false
		};
	}

	public render() {
		return (
			<Layout>
				<Layout.Content className='LogIn-content'>
					<Row className='box-login' type='flex'>
						<Col xs={0} sm={0} md={0} lg={12} xl={12} xxl={12}>
							<BoxPresentation />
						</Col>
						<Col  xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
							{this.renderContent()}
						</Col>
					</Row>
				</Layout.Content>
			</Layout>
		);
	}

	private renderContent() {
		return (
			<Spin tip="Verificando Credenciales" spinning={this.props.isChecking}>
				<CSSTransition
					in={!this.state.recovery}
					timeout={300}
					classNames='page'
					unmountOnExit>
					<BoxForm
						message={this.props.message}
						isChecking={this.props.isChecking}
						onLogIn={this.props.onLogin}
						onRecoveryShow={this.onRecoveryToggle.bind(this)}
					/>
				</CSSTransition>
				<ForgetPassword
					isOpen={this.state.recovery}
					onClose={this.onRecoveryToggle.bind(this)}
					onChange={this.onRecovery.bind(this)}
				 />
			</Spin>
		);
	}

	private setStatus(status: EStatusRequest) {
		this.props.setStatus(status);
	}

	private onRecovery(data: any) {
		this.props.onRecovery(data);
	}

	private onRecoveryToggle() {
		this.setState({
			recovery: !this.state.recovery,
			animated: !this.state.animated
		});
	}
}


export default LogIn;
